import React from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Markhópalistar - {WEBPAGE_TITLE}</title>
            </Head>
            <InfoSection>
                <ServiceHeader image="/img/thjonusta/simsvorun.png" title="Markhópalistar" />
                <p>
                    &THORN;arf &thorn;itt fyrirt&aelig;ki a&eth; n&aacute; &iacute;
                    &aacute;kve&eth;inn markh&oacute;p fyrir s&ouml;luverkefni e&eth;a
                    marka&eth;sk&ouml;nnun?
                </p>
                <p>
                    1819 uppl&yacute;singaveitur halda utan um gagnagrunn yfir alla &thorn;&aacute;
                    sem eru me&eth; skr&aacute;&eth; s&iacute;man&uacute;mer &iacute;
                    s&iacute;maskr&aacute;. Gagnagrunninn er au&eth;velt a&eth; flokka eftir
                    markh&oacute;pum og l&iacute;ti&eth; m&aacute;l er a&eth; taka &uacute;t alla
                    &thorn;&aacute; a&eth;ila sem ekki vilja f&aacute; s&iacute;mhringingar
                    fyrirt&aelig;kja sem stunda beina marka&eth;ssetningu. Markh&oacute;palistar
                    n&yacute;tast &oacute;l&iacute;kum fyrirt&aelig;kjum vi&eth; &yacute;miskonar
                    verkefni!
                </p>
                <p>
                    Vi&eth; bj&oacute;&eth;um upp &aacute; skilgreiningu markh&oacute;pa eftir
                    aldri, kyni og b&uacute;setu &thorn;egar &thorn;a&eth; kemur a&eth;
                    einstaklingum. &THORN;egar a&eth; &thorn;a&eth; kemur a&eth; fyrirt&aelig;kjum
                    er til d&aelig;mis h&aelig;gt a&eth; skipta &thorn;eim ni&eth;ur &iacute;
                    markh&oacute;pa eftir st&aelig;r&eth;, hversu lengi fyrirt&aelig;ki hafa
                    veri&eth; starfr&aelig;kt, sta&eth;setningu &thorn;eirra e&eth;a atvinnugreinum.
                </p>
                <p>D&aelig;mi um markh&oacute;palista.</p>
                <p>
                    <strong>Einstaklingar</strong>
                </p>
                <ul style={{ listStyleType: "circle" }}>
                    <li>
                        Karlmenn &aacute; aldrinum 20 &ndash; 30 &aacute;ra &iacute;
                        K&oacute;pavogi.
                    </li>
                    <li>Konur &aacute; aldrinum 40 &ndash; 60 &aacute;ra &aacute; Akureyri.</li>
                    <li>
                        Einstaklingar &aacute; aldrinum 23-46 &aacute;ra b&uacute;settir &aacute;
                        Austurlandi.
                    </li>
                </ul>
                <p>
                    <strong>Fyrirt&aelig;ki.</strong>
                </p>
                <ul style={{ listStyleType: "circle" }}>
                    <li>
                        Allir veitingasta&eth;ir &aacute; h&ouml;fu&eth;borgarsv&aelig;&eth;inu sem
                        hafa veri&eth; starfr&aelig;ktir lengur en &aacute;r.
                    </li>
                    <li>
                        &Ouml;ll fyrirt&aelig;ki &iacute; fer&eth;ai&eth;na&eth;i sem starfa utan
                        h&ouml;fu&eth;borgasv&aelig;&eth;is.
                    </li>
                    <li>300 st&aelig;rstu fyrirt&aelig;kin &aacute; &Iacute;slandi.</li>
                </ul>
                <p>
                    <strong>&nbsp;</strong>
                </p>
                <p>
                    <strong>
                        <u>Hva&eth;an eru g&ouml;gnin s&oacute;tt?</u>
                    </strong>
                </p>
                <p>
                    Vi&eth; vinnslu markh&oacute;palista eru uppl&yacute;singar s&oacute;ttar
                    &iacute; gagnagrunn 1819 sem bygg&eth;ur er &aacute; sameiginlegum grunni allra
                    fjarskiptafyrirt&aelig;kjanna. &THORN;essi grunnur er s&iacute;&eth;an
                    samr&aelig;mdur vi&eth; &THORN;j&oacute;&eth;skr&aacute; og
                    fyrirt&aelig;kjaskr&aacute; R&iacute;kisskattstj&oacute;ra sem tryggir
                    r&eacute;ttm&aelig;ti gagnanna.
                </p>
                <p style={{ textAlign: "center" }}>
                    <a className="btn btn-primary" href="/um/fyrirtaekid/hafa-samband">
                        Hafa samband
                    </a>
                </p>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
